import * as buildingUser from './buildingUserSagas';
import * as deviceEvents from './deviceEventsSagas';
import * as deviceType from './deviceTypeSagas';
import * as building from './buildingSagas';
import * as checkIns from './checkInsSagas';
import * as session from './sessionSagas';
import * as editor from './editorSagas';
import * as device from './deviceSagas';
import * as layout from './layoutSagas';
import * as theme from './themeSagas';
import * as shell from './shellSagas';
import * as admin from './adminSagas';
import * as roles from './roleSagas';
import * as user from './userSagas';
import * as ecs from './ecsSagas';
import { Saga } from 'redux-saga';

// Note: only register top-level sagas here.
//       We don't want things like apiSagas and confirmSaga because these
//       are subordinate sagas.

function registerWithMiddleware(middleware: { run: (saga: Saga) => void }, sagas: any) {
    for (const name in sagas) {
        middleware.run(sagas[name]);
    }
}

export function registerAllWithMiddleware(middleware: { run: (saga: Saga) => void }) {
    registerWithMiddleware(middleware, {
        ...buildingUser,
        ...deviceEvents,
        ...deviceType,
        ...checkIns,
        ...building,
        ...session,
        ...editor,
        ...device,
        ...layout,
        ...theme,
        ...shell,
        ...admin,
        ...roles,
        ...user,
        ...ecs,
    });
}
